define.alias("checkout/components/seamless-checkout/checkout-variant-modal", "settings/components/seamless-checkout/checkout-variant-modal");